import {IonLoading, IonPage, IonRouterOutlet} from '@ionic/react';
import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, RouteComponentProps} from 'react-router';
import {actions, RootState} from '../store';
import ContestDetailInfoTab from "./components/ContestDetailInfoTab";
import ContestDetailMapTab from "./components/ContestDetailMapTab";
import ContestDetailSeriesTab from "./components/ContestDetailSeriesTab";
import Contest from "../domain/Contest";
import ContestDetailTabHeader from "./components/ContestDetailTabHeader";
import SearchResult from "./components/SearchResult";
import {PayloadMetaAction} from "typesafe-actions/dist/types";
import CalendarItems from "../domain/CalendarItems";
import ContestDetailContentComponent from "./components/ContestDetailContentComponent";
import {PluginListenerHandle, Plugins} from "@capacitor/core";

type ContestDetailPageProps = RouteComponentProps<{ contestId: string, tab: string }> & typeof mapDispatchToProps & {
  contest?: Contest,
  lastUpdatedTimeStamp: Date,
  calendarItems: CalendarItems
};

type State = {
  showLoading: boolean;
  searchValue?: string;
}

class ContestDetailPage extends React.Component<ContestDetailPageProps, State> {
  private isCommingFromSearchScreen: boolean = false;
  private backButtonHandle ?: PluginListenerHandle;


  constructor(props: ContestDetailPageProps) {
    super(props);
    this.state = {
      searchValue: "",
      showLoading: false
    };
    props.updateContest(props.match.params.contestId);
  }

  componentDidMount(): void {
    let isSearchView = false;
    if ((this.state.searchValue && this.state.searchValue.length > 0) || this.isCommingFromSearchScreen) {
      isSearchView = true;
    }
    const isMapView = this.props.history.location.pathname.endsWith("/map");
    const isSeriesView = this.props.history.location.pathname.endsWith("/series");

    let onBack;
    if (isMapView || isSeriesView || isSearchView) {
      onBack = () => this.props.history.push(`/contests/${this.props!.contest!.id}`);
    } else {
      onBack = () => this.props.history.push("/");
    }
    this.backButtonHandle = Plugins.App.addListener('backButton', onBack);

    setTimeout(() => {
      if (this.props.contest === undefined) {
        this.setState({showLoading: true})
      }
    }, 150);
    // @ts-ignore
    this._isUnMounting = false;
  }

  componentWillUnmount(): void {
    // @ts-ignore
    this._isUnMounting = true;
    this.backButtonHandle!.remove()
  }

  componentDidUpdate(prevProps: Readonly<RouteComponentProps<{ contestId: string; tab: string }> & { updateContest: (contestId: string) => PayloadMetaAction<string, string, undefined> } & { contest?: Contest; lastUpdatedTimeStamp: Date }>, prevState: Readonly<State>, snapshot?: any): void {
    let isSearchView = false;
    if ((this.state.searchValue && this.state.searchValue.length > 0) || this.isCommingFromSearchScreen) {
      isSearchView = true;
    }
    const isMapView = this.props.history.location.pathname.endsWith("/map");
    const isSeriesView = this.props.history.location.pathname.endsWith("/series");

    let onBack;
    if (isMapView || isSeriesView || isSearchView) {
      onBack = () => {
        this.props.history.push(`/contests/${this.props!.contest!.id}`);
        this.setState({searchValue: ""})
      }
    } else {
      onBack = () => this.props.history.push("/");
    }
    if(this.backButtonHandle){
      this.backButtonHandle!.remove();
    }
    this.backButtonHandle = Plugins.App.addListener('backButton', onBack);

    this.isCommingFromSearchScreen = (prevState.searchValue !== undefined && prevState.searchValue.length > 0);

    setTimeout(() => {
      if (this.props.contest !== undefined && this.state.showLoading) {
        // @ts-ignore
        if (!this._isUnmounting) {
          this.setState({showLoading: false})
        }
      }
      if (this.props.contest === undefined && !this.state.showLoading) {
        if (this.props.contest === undefined) {
          // @ts-ignore
          if (!this._isUnmounting) {
            this.setState({showLoading: true})
          }
        }
      }
    }, 150)
  }

  render() {
    const withSearchProps = {
      searchBarEnabled: true,
      onSearchChanged: (value?: string) => this.setState({searchValue: value}),
      searchValue: this.state.searchValue
    };
    const withoutSearchProps = {
      searchBarEnabled: false
    };

    const isMapView = this.props.history.location.pathname.endsWith("/map");
    const isSeriesView = this.props.history.location.pathname.endsWith("/series");

    let searchProps;
    if (!this.props.contest) {
      searchProps = withoutSearchProps;
    } else if ((this.state.searchValue && this.state.searchValue.length > 0) || this.isCommingFromSearchScreen) {
      searchProps = withSearchProps;
    } else {
      searchProps = withSearchProps;
    }

    let onBack;
    if (isMapView || isSeriesView) {
      onBack = () => this.props.history.push(`/contests/${this.props!.contest!.id}`);
    } else {
      onBack = () => this.props.history.push("/");
    }

    return (
      <IonPage>
        <ContestDetailTabHeader
          {...this.props}
          {...searchProps}
          onBack={onBack}
          canGoBack={!this.props.calendarItems.isEmpty()}/>
        <ContestDetailContentComponent {...this.props} searchValue={this.state.searchValue}/>
      </IonPage>
    );
  }

  private renderLoading() {
    return (
      <IonLoading
        isOpen={this.state.showLoading}
        onDidDismiss={() => {
        }}
        message={'Loading...'}
        duration={3000}
      />
    );
  }

  private renderSearchResult() {
    return (
      <SearchResult contest={this.props.contest!} searchValue={this.state.searchValue!}/>
    );
  }

  private renderContestDetail(searchProps: any) {
    return (
      <>
        <Route exact
               path={`/contests/${this.props.match.params.contestId}`}
               render={() => <Redirect to={`/contests/${this.props.match.params.contestId}/info`}/>}
        />
        <IonRouterOutlet>
          <Route path={`/contests/${this.props.match.params.contestId}/:tab(info)`}
                 component={() => <ContestDetailInfoTab contest={this.props.contest!}
                                                        history={this.props.history} {...searchProps}/>}
                 outlet={"tab"} exact={true}/>
          <Route path={`/contests/${this.props.match.params.contestId}/:tab(map)`}
                 component={() => <ContestDetailMapTab contest={this.props.contest!}
                                                       history={this.props.history} {...searchProps}/>}
                 outlet={"tab"} exact={true}/>
          <Route path={`/contests/${this.props.match.params.contestId}/:tab(series)`}
                 component={() => <ContestDetailSeriesTab contest={this.props.contest!}
                                                          history={this.props.history} {...this.props} {...searchProps}/>}
                 outlet={"tab"} exact={true}/>
        </IonRouterOutlet>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    calendarItems: state.calendar.thisWeeksCalendarItems,
    contest: state.contest.contest,
    lastUpdatedTimeStamp: state.contest.lastUpdatedTimeStamp,
  }
};

const mapDispatchToProps = {
  updateContest: (contestId: string) => actions.contest.updateContest(contestId)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContestDetailPage);
